import { useState } from 'react';
import { Link } from 'react-router-dom';

import SearchBar from './common/SearchBar';


function CategoryCard({categoryId, categoryName}){

  if (categoryName) {
    return(
      <div className="col-3 p-3">
        <Link className="lk-link" to={`/category/` + categoryId}>
          <div className="card lk-border category-card">
            <div className="card-body">
              <p className="m-2"> {categoryName}</p>
            </div>    
          </div>
        </Link> 
      </div>
    );
  }
}


function CategoryCardsRow({categories}){

  if (categories) {
    let row_categories = [];
    for (let cat in categories) {
      row_categories.push(  
        <CategoryCard         
          key={cat} 
          categoryId={categories[cat].id}
          categoryName={categories[cat].category_name}
        />
      );
    }
    return(
      <>
        <div className="row mt-3 pe-3">
          {row_categories}
        </div>  
      </>
    );
  }
}

function FoundNomenclature({nomenclature}){

  
  // номенклатуры ВНУК
  let price = 0;
  if (nomenclature.nomenclature.type === "ВНУК") {
    price = nomenclature.price + nomenclature.nomenclature.base_price;
    console.log('ВНУК')
  } else {
    price = nomenclature.price
  }

 
  return (
    <div className='p-2 pt-3 border-bottom'>
      <Link 
        className="lk-link" 
        to={`/product/` + nomenclature.id}
        target="_blank" 
        rel="noopener noreferrer"
      >
        <p>{nomenclature.nomenclature.catalog_entry.catalog_number}</p>
        <p className='text-break'>{nomenclature.nomenclature.name}</p>
      </Link> 
      <p> {price} рублей</p>
    </div>
  )
}


export default function CatalogCategories({categories, goodsList, selectedYear}) {

  const [searchText, setSearchText] = useState('');
  let length = categories.length;
  let rows_number = 0;
  let rows = [];
  
  if (length % 4 === 0) {
    rows_number = length / 4;
  } else {
    rows_number = Math.ceil(length / 4);
  }
  
  for (let i = 1; i <= rows_number;) {

    let categoriesChunkIndex = i * 4;
    let row_content = [];
    for (let j = 4; j >= 1;) {
      let categoryListIndex = 0;
      categoryListIndex = categoriesChunkIndex - j;

      if (categoryListIndex < categories.length) {
        row_content.push(categories[categoryListIndex]);
      }
      j --
    }
    rows.push(
      <CategoryCardsRow         
        key={i} 
        categories={row_content}
      /> 
    );
    
    i ++
  }

  // Global Catalog Search 
  let searchedRows = [];

  if (searchText !== "") {

    for(let i in goodsList) {
      if ((goodsList[i].nomenclature.name.toLowerCase().indexOf(searchText.toLowerCase()) === -1) &&
      goodsList[i].nomenclature.catalog_entry.catalog_number.toLowerCase().indexOf(searchText.toLowerCase()) === -1) {
        //pass
      } else {
        searchedRows.push(
          <FoundNomenclature
            nomenclature={goodsList[i]}
          />
        );
      }
    }
  }

  return(
    <>
      <div className="row">
        <div className="col-3">
          <h3 className="m-3">Каталог {selectedYear}</h3>
        </div>
        <div className="col-7">
        </div>
        <div className="col-2 pt-3 px-4 border-start">
          <SearchBar
            key = "SearchBar" 
            onSearchtextChange={setSearchText} 
          />
        </div>
      </div>

      <div className="row">
        <div className="col-10">
          {rows} 
        </div>
        <div className="col-2 pt-4 px-4 border-start">
          <div className='mt-2 global-search-panel'>
            {searchedRows} 
          </div>
        </div>
      </div>
    </>
  );
}
